import Vue from 'vue'
import Router from 'vue-router';
import main from "@/views/main/main.vue";
Vue.use(Router)
var originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
let defaultRouter = [
	{
		path: '/',
		redirect: '/app/login'
	},
	{
		path: '/app',
		component: main,
		children: [
			{
				path: '/app/login',
				name: 'app_login',
				component: (resolve) => require(['@/views/login/index.vue'], resolve),
			},
			{
				path: '/app/register',
				name: 'app_register',
				component: (resolve) => require(['@/views/register/index.vue'], resolve),
			},
			{
				path: '/app/auth',
				name: 'app_auth',
				component: (resolve) => require(['@/views/auth/index.vue'], resolve),
			},
			{
				path: '/app/chat',
				name: 'app_chat',
				component: (resolve) => require(['@/views/chat/index.vue'], resolve),
			},
			{
				path: '/app/mcp',
				name: 'app_mcp',
				component: (resolve) => require(['@/views/mcp/index.vue'], resolve),
			},
			{
				path: '/app/systemtips',
				name: 'app_systemtips',
				component: (resolve) => require(['@/views/systemtips/index.vue'], resolve),
			},
			{
				path: '/app/clawbot',
				name: 'app_clawbot',
				component: (resolve) => require(['@/views/clawbot/index.vue'], resolve),
			},
		]
	},
	{
		path: '/admin',
		component: (resolve) => require(['@/views/admin/index.vue'], resolve),
		children: [
			{
				path: '/admin/shopeeshops',
				name: 'admin_shopeeshops',
				component: (resolve) => require(['@/views/shopeeshops/index.vue'], resolve),
			},
			{
				path: '/admin/lazadashops',
				name: 'admin_lazadashops',
				component: (resolve) => require(['@/views/lazadashops/index.vue'], resolve),
			},
			{
				path: '/admin/tiktokshops',
				name: 'admin_tiktokshops',
				component: (resolve) => require(['@/views/tiktokshops/index.vue'], resolve),
			},
			{
				path: '/admin/shopeeaddresslist',
				name: 'admin_shopeeaddresslist',
				component: (resolve) => require(['@/views/shopeeshops/addresslist.vue'], resolve),
			},
		]
	},
];
var router = new Router({
	mode: "history",
	// mode: process.env.MODE,
	routes: defaultRouter
});
router.beforeEach((to, from, next) => {
	next();
});
export default router;